export const OLDER_ADULTS_GET_SUCCESS = 'OLDER_ADULTS_GET_SUCCESS';
export const OLDER_ADULTS_GET_FAILURE = 'OLDER_ADULTS_GET_FAILURE';

export const OLDER_ADULTS_SUCCESS = 'OLDER_ADULTS_SUCCESS';
export const OLDER_ADULTS_FAILURE = 'OLDER_ADULTS_FAILURE';
